import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { validateField } from "../../apicall/commonFunction";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import { updateobj } from "../../apicall/apicall";
import { dev } from "../../apicall/constants";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ReplaceDevices(props) {
  const [deviceData, setDeviceData] = React.useState({
    dev_id: props.selectedDevice.device_id
      ? props.selectedDevice.device_id
      : "",
    imei_number: props.selectedDevice.old_device_imei
      ? props.selectedDevice.old_device_imei
      : "",
    iccid: props.selectedDevice.old_device_iccid
      ? props.selectedDevice.old_device_iccid
      : "",
    serial_number: props.selectedDevice.old_device_sn
      ? props.selectedDevice.old_device_sn
      : "",
  });
  const validateForm = (data) => {
    const newErrors = {};
    if (!data.imei_number.trim()) {
      newErrors.imei_number = 'IMEI Number cannot be blank';
    }

    if (!data.iccid.trim()) {
      newErrors.last_name = 'ICCID/SIM cannot be blank';
    }

    

    let val = validateField(data, dev);
    // console.log(val, "--------------------------------");
    if (Object.keys(val).length > 0) {
      Object.keys(val).forEach((field) => {
        console.log(field);
        newErrors[field] = val[field];
      });}

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return false;
    }
    return true;
  }


  const [error, setError] = React.useState({})

  const handleClose = () => {
    props.setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDeviceData({ ...deviceData, [name]: value });
  };

  const dataProcess = (deviceData) => {
    if (typeof deviceData === 'object' && deviceData !== null) {
      for (let key in deviceData) {
          if (typeof deviceData[key] === 'string') {
              deviceData[key] = deviceData[key].trim();
          } else if (typeof deviceData[key] === 'object') {
            dataProcess(deviceData[key]); // Recursively trim nested objects or arrays
          }
      }
  }
  return deviceData;
  };

  const handleSubmit = async (e) => {
    let data = dataProcess(deviceData)
    let val =validateForm(data)
    const url = process.env.REACT_APP_ZEWA_URL + "replace-device/replace/";
    if (!val) return;
    // console.log(val,"///")
    if (
      data["imei_number"] === "" ||
      data["imei_number"] === undefined ||
      data["iccid"] === "" ||
      data["iccid"] === undefined 
    ) {
      NotificationManager.error(
        "IMEI and SIM field can not be blank.",
        "Error",
        3000
      );
      return;
    }
    const res = await updateobj(url, data);
    if (res.status === 200) {
      props.setOpen(false);
      setTimeout(() => {
        NotificationManager.success(
          "Device replaced successfully.",
          "Success",
          4000
        );
      }, 5000);

      props.setLoadData(!props.loadData);
      return;
    }
    NotificationManager.error("Failed to replace device.", "Error", 3000);
    handleClose();
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Replace Device
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="imei_number"
            label="IMEI"
            helperText={error.imei_number ? error.imei_number : ""}
          error={error.imei_number || false}
            type="text"
            fullWidth
            variant="standard"
            value={deviceData["imei_number"]}
            placeholder={props.selectedDevice.old_device_imei}
            onChange={handleChange}
          />
          <TextField
            autoFocus
            required
            margin="dense"
            id="ICCID"
            name="iccid"
            helperText={error.iccid ? error.iccid : ""}
            error={error.iccid || false}
            value={deviceData["iccid"]}
            label="ICCID/SIM"
            type="text"
            fullWidth
            variant="standard"
            placeholder={props.selectedDevice.old_device_iccid}
            onChange={handleChange}
          />

          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="serial_number"
            label="Serial Number"
            helperText={error.serial_number ? error.serial_number : ""}
            error={error.serial_number || false}
            value={deviceData["serial_number"]}
            type="text"
            fullWidth
            variant="standard"
            placeholder={props.selectedDevice.old_device_sn}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="outlined"
            color="error"
            onClick={handleClose}
          >
            CANCEL
          </Button>
          <Button
            autoFocus
            variant="outlined"
            color="primary"
            onClick={handleSubmit}
          >
            UPDATE
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <NotificationContainer />
    </React.Fragment>
  );
}
